import React, { useContext } from 'react';
import { LoadingContext } from './LoadingContext';

const GlobalLoader = () => {
  const { isLoading } = useContext(LoadingContext);

  if (!isLoading) {
    return null; // Don't render anything if not loading
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.9)', // Semi-transparent white
        zIndex: 9999, // Ensure it's on top
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.5em',
        color: '#333'
      }}
    >
      Loading...
    </div>
  );
};

export default GlobalLoader; 